import React from "react";

import styles from "~/pages/CharacterSheet/widgets/CharacterNameInput/CharacterNameInput.module.scss";

export interface CharacterNameInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    labelSuffix?: React.ReactNode;
}

/**
 * CharacterNameInput widget for entering the character's name.
 * Displays a styled label and large text input.
 */
const CharacterNameInput: React.FC<CharacterNameInputProps> = ({
  value,
  onChange,
  placeholder = "Enter name...",
  labelSuffix,
}) => {
  return (
    <div className={styles.nameField}>
      <div className={styles.labelRow}>
        <label htmlFor="charName" className={styles.label}>
          Character Name
        </label>
        {labelSuffix && <div className={styles.labelSuffix}>{labelSuffix}</div>}
      </div>
      <input
        id="charName"
        type="text"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        className={styles.nameInput}
        placeholder={placeholder}
      />
    </div>
  );
};

export default CharacterNameInput;
